import styled from '@emotion/native';
import type { ColorName } from '@emotion/react';
import { useTheme } from 'design-system/theme';
import type { PropsWithChildren } from 'react';

interface DotProps {
  size?: number;
  color?: ColorName;
  marginRight?: number;
}

export const Dot = styled.View<PropsWithChildren<DotProps>>(
  ({ size = 8, color = 'primary', marginRight = 6 }) => {
    const theme = useTheme();

    const dotColor = theme.color[color] || color;

    return {
      width: size,
      height: size,
      borderRadius: size / 2,
      backgroundColor: dotColor,
      marginRight,
    };
  },
);
